var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildcardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.389,
    height: 11.191,
    viewBox: "0 0 14.389 11.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter-list-alt-svgrepo-com",
    d: "M4.6,9a.8.8,0,0,1,.8-.8h9.593a.8.8,0,1,1,0,1.6H5.4A.8.8,0,0,1,4.6,9Zm1.6,3.2a.8.8,0,0,1,.8-.8h6.4a.8.8,0,0,1,0,1.6H7A.8.8,0,0,1,6.2,12.194Zm1.6,3.2a.8.8,0,0,1,.8-.8h3.2a.8.8,0,0,1,0,1.6H8.6A.8.8,0,0,1,7.8,15.392ZM3,5.8A.8.8,0,0,1,3.8,5h12.79a.8.8,0,1,1,0,1.6H3.8A.8.8,0,0,1,3,5.8Z",
    transform: "translate(-3 -5)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildcardIcon);
export default __webpack_public_path__ + "static/media/wildcard-icon.0b725bce3fd7bcbc4e3e3df9cf8aa2dd.svg";
export { ForwardRef as ReactComponent };